import type { NextPage } from 'next';

import HeroTitle from '@web/components/hero-block/hero-title/hero-title';

import TemplateLayout from '@web/layouts/template/template';

import { HeroAlignment } from '@web/services/umbraco/types/basic/Alignment';
import { BackgroundColor } from '@web/services/umbraco/types/basic/Color';
import { UmbracoPage } from '@web/services/umbraco/types/documents/UmbracoDocument';

import { MembershipContactInfo } from './membership-contact-info/membership-contact-info';

export const userContactInfoPageContentAlias = 'userContactInfoPage' as const;

export type UserContactInfoPageData = UmbracoPage<
	typeof userContactInfoPageContentAlias,
	{
		title: string;
		subtitle: string;
	}
>;

const UserContactInfoPageTemplate: NextPage<{ pageData: UserContactInfoPageData }> = ({ pageData }) => {
	const { title, subtitle } = pageData.properties;

	return (
		<TemplateLayout>
			<HeroTitle
				title={title}
				subtitle={subtitle}
				alignment={HeroAlignment.Left}
				background={BackgroundColor.White}
			/>
			<MembershipContactInfo />
		</TemplateLayout>
	);
};

export default UserContactInfoPageTemplate;
